// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__Jzjkb8rHXWFd8","chips":"chips__+rDBj4tFbspmg"};